export const palette = {
  navy: '#1b294c',
  gold: '#cb9662',
  surface: '#f6f6f6',
  white: '#ffffff',
  link: '#4599c7',
} as const;
